import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import logo from "../img/logospace.jpg";
import { Link } from 'react-router-dom';

const NavbarComponent = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);
  
  return (
    <div> 
      <Navbar light> 
        <div className="navLine">
          <div id="imgContainer">     
            <img className='navbar-img' src ={logo} alt=''/>
          </div>
            <NavbarBrand href="/" className="titleNav">ISS SPACESHIP VIEWER</NavbarBrand>       
            <div id="burgerContainer"> 
            <NavbarToggler className="btnBurger" onClick={toggleNavbar}  />
            </div>
        </div>
        <Collapse isOpen={!collapsed} >
          <Nav className= "burgerNav navLine2">           
        
            <NavItem  className="burgerNav">
              <NavLink onClick={toggleNavbar} tag={Link} to="/Live">LIVE</NavLink>
            </NavItem>

            <NavItem className="burgerNav">
              <NavLink  onClick={toggleNavbar} tag={Link} to="/map3D">MAP 3D</NavLink>
            </NavItem>
        
            <NavItem className="burgerNav">
              <NavLink onClick={toggleNavbar} tag={Link} to="/IssView">ISS STREETVIEW</NavLink>
            </NavItem>
        
            <NavItem className="burgerNav">
              <NavLink onClick={toggleNavbar} tag={Link} to="/pictureOfDay">PIC OF DAY</NavLink>
            </NavItem>
        
            <NavItem className="burgerNav">
              <NavLink onClick={toggleNavbar} tag={Link} to="/GamePlanet">GLOSSARY</NavLink>
            </NavItem>
        
            <NavItem className="burgerNav">
              <NavLink tag={Link} to="/Quiz">QUIZ</NavLink>
            </NavItem>
        
            <NavItem className="burgerNav minigames">
              <NavLink onClick={toggleNavbar} tag={Link} to="/Minigame">MINI GAMES</NavLink>
            </NavItem>
          </Nav>
        </Collapse>        
      </Navbar>
      </div>
  );
}
export default NavbarComponent;